<vt-layout>
  <vt-toolbar (openHelp)="onOpenHelp()"></vt-toolbar>

  <router-outlet></router-outlet>

  <vt-footer></vt-footer>
</vt-layout>